import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeDsn, logger, checkOrSetAlreadyCaught, isPrimitive, resolvedSyncPromise, addItemToEnvelope, createAttachmentEnvelopeItem, SyncPromise, rejectedSyncPromise, SentryError, isThenable, isPlainObject } from '@sentry/utils';
import { getEnvelopeEndpointWithUrlEncodedAuth } from './api.js';
import { createEventEnvelope, createSessionEnvelope } from './envelope.js';
import { setupIntegrations as _setupIntegrations, setupIntegration } from './integration.js';
import { updateSession } from './session.js';
import { getDynamicSamplingContextFromClient } from './tracing/dynamicSamplingContext.js';
import { prepareEvent } from './utils/prepareEvent.js';
var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */

var BaseClient = /*#__PURE__*/function () {
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  function BaseClient(options) {
    _classCallCheck(this, BaseClient);

    BaseClient.prototype.__init.call(this);

    BaseClient.prototype.__init2.call(this);

    BaseClient.prototype.__init3.call(this);

    BaseClient.prototype.__init4.call(this);

    BaseClient.prototype.__init5.call(this);

    this._options = options;

    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('No DSN provided, client will not do anything.');
    }

    if (this._dsn) {
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport(_objectSpread(_objectSpread({
        recordDroppedEvent: this.recordDroppedEvent.bind(this)
      }, options.transportOptions), {}, {
        url: url
      }));
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types


  _createClass(BaseClient, [{
    key: "__init",
    value:
    /** Options passed to the SDK. */

    /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

    /** Array of set up integrations. */
    function __init() {
      this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */

  }, {
    key: "__init2",
    value: function __init2() {
      this._integrationsInitialized = false;
    }
    /** Number of calls being processed */

  }, {
    key: "__init3",
    value: function __init3() {
      this._numProcessing = 0;
    }
    /** Holds flushable  */

  }, {
    key: "__init4",
    value: function __init4() {
      this._outcomes = {};
    } // eslint-disable-next-line @typescript-eslint/ban-types

  }, {
    key: "__init5",
    value: function __init5() {
      this._hooks = {};
    }
  }, {
    key: "captureException",
    value: function captureException(exception, hint, scope) {
      var _this = this;

      // ensure we haven't captured this very object before
      if (checkOrSetAlreadyCaught(exception)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log(ALREADY_SEEN_ERROR);
        return;
      }

      var eventId = hint && hint.event_id;

      this._process(this.eventFromException(exception, hint).then(function (event) {
        return _this._captureEvent(event, hint, scope);
      }).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureMessage",
    value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
      var _this2 = this;

      var eventId = hint && hint.event_id;
      var promisedEvent = isPrimitive(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);

      this._process(promisedEvent.then(function (event) {
        return _this2._captureEvent(event, hint, scope);
      }).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureEvent",
    value: function captureEvent(event, hint, scope) {
      // ensure we haven't captured this very object before
      if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log(ALREADY_SEEN_ERROR);
        return;
      }

      var eventId = hint && hint.event_id;

      this._process(this._captureEvent(event, hint, scope).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureSession",
    value: function captureSession(session) {
      if (!this._isEnabled()) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('SDK not enabled, will not capture session.');
        return;
      }

      if (!(typeof session.release === 'string')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Discarded session because of missing or non-string release');
      } else {
        this.sendSession(session); // After sending, we set init false to indicate it's not the first occurrence

        updateSession(session, {
          init: false
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getDsn",
    value: function getDsn() {
      return this._dsn;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }
    /**
     * @see SdkMetadata in @sentry/types
     *
     * @return The metadata of the SDK
     */

  }, {
    key: "getSdkMetadata",
    value: function getSdkMetadata() {
      return this._options._metadata;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getTransport",
    value: function getTransport() {
      return this._transport;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "flush",
    value: function flush(timeout) {
      var transport = this._transport;

      if (transport) {
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
          return transport.flush(timeout).then(function (transportFlushed) {
            return clientFinished && transportFlushed;
          });
        });
      } else {
        return resolvedSyncPromise(true);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "close",
    value: function close(timeout) {
      var _this3 = this;

      return this.flush(timeout).then(function (result) {
        _this3.getOptions().enabled = false;
        return result;
      });
    }
    /**
     * Sets up the integrations
     */

  }, {
    key: "setupIntegrations",
    value: function setupIntegrations() {
      if (this._isEnabled() && !this._integrationsInitialized) {
        this._integrations = _setupIntegrations(this._options.integrations);
        this._integrationsInitialized = true;
      }
    }
    /**
     * Gets an installed integration by its `id`.
     *
     * @returns The installed integration or `undefined` if no integration with that `id` was installed.
     */

  }, {
    key: "getIntegrationById",
    value: function getIntegrationById(integrationId) {
      return this._integrations[integrationId];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getIntegration",
    value: function getIntegration(integration) {
      try {
        return this._integrations[integration.id] || null;
      } catch (_oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
        return null;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addIntegration",
    value: function addIntegration(integration) {
      setupIntegration(integration, this._integrations);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "sendEvent",
    value: function sendEvent(event) {
      var _this4 = this;

      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._dsn) {
        var env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

        var _iterator = _createForOfIteratorHelper(hint.attachments || []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attachment = _step.value;
            env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var promise = this._sendEnvelope(env);

        if (promise) {
          promise.then(function (sendResponse) {
            return _this4.emit('afterSendEvent', event, sendResponse);
          }, null);
        }
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "sendSession",
    value: function sendSession(session) {
      if (this._dsn) {
        var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        void this._sendEnvelope(env);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "recordDroppedEvent",
    value: function recordDroppedEvent(reason, category, _event) {
      // Note: we use `event` in replay, where we overwrite this hook.
      if (this._options.sendClientReports) {
        // We want to track each category (error, transaction, session, replay_event) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        // With typescript 4.1 we could even use template literal types
        var key = "".concat(reason, ":").concat(category);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Adding outcome: \"".concat(key, "\"")); // The following works because undefined + 1 === NaN and NaN is falsy

        this._outcomes[key] = this._outcomes[key] + 1 || 1;
      }
    } // Keep on() & emit() signatures in sync with types' client.ts interface

    /** @inheritdoc */

    /** @inheritdoc */

  }, {
    key: "on",
    value: function on(hook, callback) {
      if (!this._hooks[hook]) {
        this._hooks[hook] = [];
      } // @ts-ignore We assue the types are correct


      this._hooks[hook].push(callback);
    }
    /** @inheritdoc */

    /** @inheritdoc */

  }, {
    key: "emit",
    value: function emit(hook) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (this._hooks[hook]) {
        // @ts-ignore we cannot enforce the callback to match the hook
        this._hooks[hook].forEach(function (callback) {
          return callback.apply(void 0, rest);
        });
      }
    }
    /** Updates existing session based on the provided event */

  }, {
    key: "_updateSessionFromEvent",
    value: function _updateSessionFromEvent(session, event) {
      var crashed = false;
      var errored = false;
      var exceptions = event.exception && event.exception.values;

      if (exceptions) {
        errored = true;

        var _iterator2 = _createForOfIteratorHelper(exceptions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ex = _step2.value;
            var mechanism = ex.mechanism;

            if (mechanism && mechanism.handled === false) {
              crashed = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } // A session is updated and that session update is sent in only one of the two following scenarios:
      // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
      // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update


      var sessionNonTerminal = session.status === 'ok';
      var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;

      if (shouldUpdateAndSend) {
        updateSession(session, _objectSpread(_objectSpread({}, crashed && {
          status: 'crashed'
        }), {}, {
          errors: session.errors || Number(errored || crashed)
        }));
        this.captureSession(session);
      }
    }
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */

  }, {
    key: "_isClientDoneProcessing",
    value: function _isClientDoneProcessing(timeout) {
      var _this5 = this;

      return new SyncPromise(function (resolve) {
        var ticked = 0;
        var tick = 1;
        var interval = setInterval(function () {
          if (_this5._numProcessing == 0) {
            clearInterval(interval);
            resolve(true);
          } else {
            ticked += tick;

            if (timeout && ticked >= timeout) {
              clearInterval(interval);
              resolve(false);
            }
          }
        }, tick);
      });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */

  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */

  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, scope) {
      var _this6 = this;

      var options = this.getOptions();
      var integrations = Object.keys(this._integrations);

      if (!hint.integrations && integrations.length > 0) {
        hint.integrations = integrations;
      }

      return prepareEvent(options, event, hint, scope).then(function (evt) {
        if (evt === null) {
          return evt;
        } // If a trace context is not set on the event, we use the propagationContext set on the event to
        // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
        // also generate one for it.


        var _ref = evt.sdkProcessingMetadata || {},
            propagationContext = _ref.propagationContext;

        var trace = evt.contexts && evt.contexts.trace;

        if (!trace && propagationContext) {
          var trace_id = propagationContext.traceId,
              spanId = propagationContext.spanId,
              parentSpanId = propagationContext.parentSpanId,
              dsc = propagationContext.dsc;
          evt.contexts = _objectSpread({
            trace: {
              trace_id: trace_id,
              span_id: spanId,
              parent_span_id: parentSpanId
            }
          }, evt.contexts);
          var dynamicSamplingContext = dsc ? dsc : getDynamicSamplingContextFromClient(trace_id, _this6, scope);
          evt.sdkProcessingMetadata = _objectSpread({
            dynamicSamplingContext: dynamicSamplingContext
          }, evt.sdkProcessingMetadata);
        }

        return evt;
      });
    }
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */

  }, {
    key: "_captureEvent",
    value: function _captureEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scope = arguments.length > 2 ? arguments[2] : undefined;
      return this._processEvent(event, hint, scope).then(function (finalEvent) {
        return finalEvent.event_id;
      }, function (reason) {
        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          var sentryError = reason;

          if (sentryError.logLevel === 'log') {
            logger.log(sentryError.message);
          } else {
            logger.warn(sentryError);
          }
        }

        return undefined;
      });
    }
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */

  }, {
    key: "_processEvent",
    value: function _processEvent(event, hint, scope) {
      var _this7 = this;

      var options = this.getOptions();
      var sampleRate = options.sampleRate;

      if (!this._isEnabled()) {
        return rejectedSyncPromise(new SentryError('SDK not enabled, will not capture event.', 'log'));
      }

      var isTransaction = isTransactionEvent(event);
      var isError = isErrorEvent(event);
      var eventType = event.type || 'error';
      var beforeSendLabel = "before send for type `".concat(eventType, "`"); // 1.0 === 100% events are sent
      // 0.0 === 0% events are sent
      // Sampling for transaction happens somewhere else

      if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
        this.recordDroppedEvent('sample_rate', 'error', event);
        return rejectedSyncPromise(new SentryError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), 'log'));
      }

      var dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
      return this._prepareEvent(event, hint, scope).then(function (prepared) {
        if (prepared === null) {
          _this7.recordDroppedEvent('event_processor', dataCategory, event);

          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        var isInternalException = hint.data && hint.data.__sentry__ === true;

        if (isInternalException) {
          return prepared;
        }

        var result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      }).then(function (processedEvent) {
        if (processedEvent === null) {
          _this7.recordDroppedEvent('before_send', dataCategory, event);

          throw new SentryError("".concat(beforeSendLabel, " returned `null`, will not send event."), 'log');
        }

        var session = scope && scope.getSession();

        if (!isTransaction && session) {
          _this7._updateSessionFromEvent(session, processedEvent);
        } // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user


        var transactionInfo = processedEvent.transaction_info;

        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          var source = 'custom';
          processedEvent.transaction_info = _objectSpread(_objectSpread({}, transactionInfo), {}, {
            source: source
          });
        }

        _this7.sendEvent(processedEvent, hint);

        return processedEvent;
      }).then(null, function (reason) {
        if (reason instanceof SentryError) {
          throw reason;
        }

        _this7.captureException(reason, {
          data: {
            __sentry__: true
          },
          originalException: reason
        });

        throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
      });
    }
    /**
     * Occupies the client with processing and event
     */

  }, {
    key: "_process",
    value: function _process(promise) {
      var _this8 = this;

      this._numProcessing++;
      void promise.then(function (value) {
        _this8._numProcessing--;
        return value;
      }, function (reason) {
        _this8._numProcessing--;
        return reason;
      });
    }
    /**
     * @inheritdoc
     */

  }, {
    key: "_sendEnvelope",
    value: function _sendEnvelope(envelope) {
      if (this._transport && this._dsn) {
        this.emit('beforeEnvelope', envelope);
        return this._transport.send(envelope).then(null, function (reason) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Error while sending event:', reason);
        });
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Transport disabled');
      }
    }
    /**
     * Clears outcomes on this client and returns them.
     */

  }, {
    key: "_clearOutcomes",
    value: function _clearOutcomes() {
      var outcomes = this._outcomes;
      this._outcomes = {};
      return Object.keys(outcomes).map(function (key) {
        var _key$split = key.split(':'),
            _key$split2 = _slicedToArray(_key$split, 2),
            reason = _key$split2[0],
            category = _key$split2[1];

        return {
          reason: reason,
          category: category,
          quantity: outcomes[key]
        };
      });
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

  }]);

  return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */


function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");

  if (isThenable(beforeSendResult)) {
    return beforeSendResult.then(function (event) {
      if (!isPlainObject(event) && event !== null) {
        throw new SentryError(invalidValueError);
      }

      return event;
    }, function (e) {
      throw new SentryError("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }

  return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */


function processBeforeSend(options, event, hint) {
  var beforeSend = options.beforeSend,
      beforeSendTransaction = options.beforeSendTransaction;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}

export { BaseClient };